module.exports = __webpack_public_path__ + "static/img/icon-sqbq.0601e659.png";